import { BusinessWithSubscriptionStateModel } from '@state/FirestoreStateBaseForBusiness';
import { Timestamp } from 'firebase/firestore';
import { LeapCard } from '@models/leap';

export interface CloserTasksModel extends BusinessWithSubscriptionStateModel {
	closerTasks: CloserTask[];
}

export enum CloserTaskName {
	CloserToLeapClientSync = 'closerToLeapClientSync',
	LeapFirmSwitch = 'leapFirmSwitch',
}

export interface CloserTask {
	id: CloserTaskName;
}

export interface CloserToLeapClientSyncTask extends CloserTask {
	results: {
		expectedCount: number;
		actualCount: number;
		personMatches: PersonMatch[];
		clientMatches: ClientMatch[];
		completionDateTimeStamp: Timestamp;
		badData: string[];
		errors: ExportError[];
	};
}

export interface ExportError {
	path: string;
	error: string;
}

export interface PersonMatch {
	merged: boolean;
	leapCardId: string;
	closerClientPerson: {
		id: string;
		firstName: string;
		middleNames: string;
		lastName: string;
		emailAddress: string;
		salutation: string;
		birthDate: string;
		lastActiveFileDate: Timestamp | null;
	};
	leapMatches: {
		personId: string;
		firstName: string;
		middleNames: string;
		lastName: string;
		salutation: string;
		emailAddress: string;
		birthDate: string;
		lastActiveFileDate: Timestamp | null;
	}[];
}

export interface ClientMatch {
	merged: boolean;
	closerClient: {
		id: string;
		name: string;
		emailAddress: string;
		birthDate: string | null;
		lastActiveFileDate: Timestamp | null;
	};
	leapMatches: {
		cardId: string;
		fullName: string;
		shortName: string;
		emailAddress: string;
		cardType: string;
	}[];
	/**
	 * Only populated if LeapMatches has 1 record. If populated, show these to users during conflict resolution.
	 */
	leapPersonMatches: {
		personId: string;
		firstName: string;
		middleNames: string;
		lastName: string;
		salutation: string;
		emailAddress: string;
		birthDate: string;
		lastActiveFileDate: Timestamp | null;
	}[];
}

export interface CloserLeapClientMap {
	closerClientId: string;
	leap?: LeapCard;
}
